
(function () {
  var form = document.querySelector('.newsletter__form');
  if (!form) return;
  var input = form.querySelector('input[type="email"]');
  var err = form.querySelector('.newsletter__err');
  var ok = form.querySelector('.newsletter__ok');
  if (!input || !err) return;

  form.noValidate = true;

  function show(text) {
    err.textContent = text;
    err.hidden = !text;
    input.setAttribute('aria-invalid', text ? 'true' : 'false');
  }

  input.addEventListener('invalid', function (e) { e.preventDefault(); });

  form.addEventListener('submit', function (e) {
    var v = input.value.trim();
    if (!v) {
      e.preventDefault();
      show(input.dataset.errortext || 'The email address must be filled');
      input.focus();
      return;
    }
    if (!input.checkValidity()) {
      e.preventDefault();
      show(input.dataset.errortext2 || 'Check that the email you entered is correct');
      input.focus();
      return;
    }
    show('');
  });

  input.addEventListener('input', function () {
    if (!err.hidden) show('');
    if (ok && !ok.hidden && !ok.textContent.trim()) ok.hidden = true;
  });
})();
